export default class ManualEvaluatorIobItem {
  constructor() {
    this.InvoicingOfficeId = 0;
    this.InvoicedOfficeId = 0;
    this.InternalReference = '';
    this.Comment = '';
  }
}
